import { type Resolution, useResolution } from '@lingoda/ui';

export type ResolutionDependentOption = Resolution | boolean;

export const getResolutionByOption = (option: ResolutionDependentOption = false): Resolution =>
    typeof option === 'boolean' ? (option ? 'all' : 'none') : option;

export const useResolveResolutionDependentOption = (
    option: ResolutionDependentOption = false,
): boolean => {
    return useResolution(getResolutionByOption(option));
};
